import { createContext } from 'react';

const MobileThemeContext = /*#__PURE__*/createContext(undefined);
var MobileThemeContext$1 = MobileThemeContext;

export { MobileThemeContext$1 as M };
//# sourceMappingURL=MobileThemeContext-15ca3ea1.js.map
